import { PageGroup, permissionsActions } from '../../store/permissions.era';
import { Component, Input, ChangeDetectorRef, OnInit, EventEmitter, Output } from '@angular/core';
import { User } from '../../../../globals/store/user.data';
import { JoiEvent } from 'globals/store/events.data';
import { Wrapper } from 'src/app/components/wrapper.component';
import { sleepForMS } from 'src/app/helpers/helpers';
import { accessTypeReselector, groupsByHandleReselector } from '../../store/reselectors/permissions.reselector';
import { canAccessBudgetReselector } from '../../store/reselectors/budget.reselector';
import { AccessType, PageGroupHandle, pageGroupsByHandles } from '../../../../globals/store/permissions.data';
import { Dictionary } from '@ngrx/entity';
import { AccountPublicInfo } from '../../../../globals/store/accounts.data';
import { uiActions } from '../../store/ui.era';
import { CommonModule } from '@angular/common';
import { PhotoComponent } from '../photo';
import { IconComponent } from '../icon/icon.component';
import { RouterLink } from '@angular/router';
import { MatTooltipModule } from '@angular/material/tooltip';
import { eventsFeature } from 'src/app/store/events.era';
import { GetGroupLink } from 'src/app/services/pipes/getGroupLink.pipe';

@Component({
    selector: 'menu-panel',
    imports: [CommonModule, PhotoComponent, GetGroupLink, IconComponent, RouterLink, MatTooltipModule],
    template: `
<div  *ngIf="!!event && !!user && show_menu && !loadingPermissions && { myTasks: access === 'crew' || access === 'facilitator' || access === 'performer' } as vars" 
  class="menus menu-panel" [ngClass]="{collapse:uiService.side_menu_collapse}">
  <div class="top_item item">
    <div class="top_item_container" *ngIf="event?.accountId &&publicAccounts[event.accountId] as account">
      <photo [data]="account" [size]="36"></photo>
      <div class="name"
        [title]="account.title || ''"
        [ngClass]="{info_loading: !account.title}">
        {{ account.title }}
      </div>
    </div>
    <div class="event_heading_for_printing_only">
      <div> {{ event?.title }}</div>
    </div>
  </div>
  <div class="grouping" *ngFor="let grouping of groupings; last as lastGrouping; trackBy: trackByIndex" [ngClass]="{ last: lastGrouping }">
    <ng-container *ngFor="let groupId of grouping; first as firstGroup; trackBy: trackBySelf">
      <ng-container *ngIf="(groupId !== 'tasks' || !vars.myTasks) && 
      (groupId !== 'my_tasks' || vars.myTasks) &&
      { fullGroup: pageGroupsByHandles[groupId], userGroup: userGroupsByHandle[groupId] } as g">
        <a class="item" 
          *ngIf="{ active: (g.userGroup?.handle && page_type === g.userGroup.handle) || (g.userGroup?.handle === 'budget'
           && inBudget), 
            url: !g.userGroup ? null : g.userGroup | getGroupLink:mobile,
            readOnly: !!g.userGroup && !g.userGroup.pages_are_editable,
            locked: !g.userGroup } as vars"
          [routerLink]="!vars.url ? null : ('/' + vars.url + '/' + event.eventId)" 
          [ngClass]="{ active: vars.active, selectable: !vars.locked, first: firstGroup }"
          (click)="vars.locked ? null : viewPage($event, g.userGroup)"
        >
          <div class="group_icon" [matTooltip]="g.fullGroup.label"
            matTooltipPosition="after" [matTooltipDisabled]="!uiService.side_menu_collapse">
            <icon [ngStyle]="{ scale: g.fullGroup.scale || 1 }"  [icon]="g.fullGroup.icon" [title]="g.fullGroup.label"></icon>
          </div>
          <div class="group_label">{{ g.fullGroup.label }}</div>
          <div style="flex: 1"></div>
          <icon class="status" *ngIf="vars.readOnly" [icon]="'VISIBILITY24'" [i18]="true"></icon>
          <icon class="status" *ngIf="vars.locked" [icon]="'LOCKED'" [i18]="true"></icon>
        </a>
      </ng-container>
    </ng-container>
  </div>
  <div class="bottom_collapse_btn desktop" (click)="uiService.side_menu_collapse = !uiService.side_menu_collapse">
      <icon [matIcon]="(uiService.side_menu_collapse ? 'keyboard_arrow_right' : 'keyboard_arrow_left')"></icon>
  </div>
</div>
    `,
    styleUrls: ['./menu-panel.component.scss'],
    standalone: true,
    
})
export class MenuPanelComponent extends Wrapper<MenuPanelComponent> implements OnInit {
  @Input() mobile = false
  @Output() viewingNewPage: EventEmitter<void> = new EventEmitter()
  user: User
  publicAccounts: Dictionary<AccountPublicInfo>
  page_type: string
  show_menu = false
  event: JoiEvent
  menuPanelNumber: number
  budgetAccess = false
  pageGroupsByHandles = pageGroupsByHandles
  loadingPermissions = true
  inBudget
  groupings: PageGroupHandle[][] = [
    ['program', 'publish', 'app'],
    ['workforce', 'resources', 'event_information', 'tasks', 'my_tasks', 'assets'],
    ['performers', 'sponsors', 'exhibitors', 'attendees'],
    ['logistics', 'schedules', 'my_schedule'],
    ['budget', 'backup']
  ]
  userGroupsByHandle: { [K in PageGroupHandle]: PageGroup } = {} as any
  access: AccessType

  ngOnInit() {
    this.selectCallback(groupsByHandleReselector, null, (userGroupsByHandle: { [K in PageGroupHandle]: PageGroup }) => {
      this.userGroupsByHandle = userGroupsByHandle
      this.changeDetectorRef.detectChanges()
    })
  }

  constructor(public changeDetectorRef: ChangeDetectorRef) {
    super()
    this.selectProp(accessTypeReselector, null, 'access')
    this.selectProp(canAccessBudgetReselector, null, 'budgetAccess')
    this.subProp(this.store.select('user', 'user'), 'user')
    this.subProp(this.store.select('accounts','public_info'), 'publicAccounts')  
    this.subProp(this.store.select('permissions','page_type'), 'page_type')
    this.subProp(this.store.select('events','event'), 'event')
    this.subProp(this.store.select('permissions', 'loading'), 'loadingPermissions')
    this.subCallback(this.store.select('router','state','url'), async(url) => {
      const inEvent = /\/event\//.test(url)
      const onDashboard = /\/event\/(dashboard)/.test(url)
      this.inBudget = /\/event\/(revenue)/.test(url) || /\/event\/(costs)/.test(url) || /\/event\/(budget)/.test(url)

      if (!inEvent) await sleepForMS(5) // for jumping to home so it doesn't disappear right away
      this.show_menu = inEvent && !onDashboard
    })
  }

  trackByGroup(_, pageGroup: PageGroup) {
    return pageGroup.handle
  }

  async viewPage(event, pageGroup: PageGroup) {
    if (event.shiftKey || event.ctrlKey || event.metaKey) return
    const mobile = window.innerWidth < 769
    const page = !mobile || !pageGroup.mobileHandles?.length ? pageGroup.pages[0] : pageGroup.mobileDefault ? pageGroup.pages.find(p => p.handle === pageGroup.mobileDefault) : pageGroup.pages.find(p => p.handle === pageGroup.mobileHandles[0])

    this.store.dispatch(uiActions.hideMobileMenu())
    this.viewingNewPage.emit()
    this.store.dispatch(permissionsActions.setPageType(pageGroup.handle))
    const eventId = await this.take1(this.store.select(eventsFeature.selectEventId))
    this.router.navigate(['/' + page.url, eventId])
  }

  signOut() {
      this.userService.signOut();
  }
}
